export const servicesText = {
  en: {
    title: "Our Team's Expertise",
    description:
      "A complete development team you can hire as one pack: developers, designers, engineers, security and cloud specialists.",
    services: [
      {
        title: "Software Developers",
        description:
          "Experienced developers who build and maintain applications across modern stacks.",
      },
      {
        title: "UX/UI Designers",
        description:
          "Designers who craft intuitive interfaces that lift user experience and business results.",
      },
      {
        title: "Software Engineers",
        description:
          "Senior engineers who architect scalable systems and keep code quality high.",
      },
      {
        title: "Cloud & DevOps Specialists",
        description:
          "Cloud infrastructure and deployment pipelines for reliable, scalable systems.",
      },
      {
        title: "Security Experts",
        description:
          "Cybersecurity specialists who protect digital assets and keep you compliant.",
      },
    ],
  },
  es: {
    title: "Expertise de Nuestro Equipo",
    description:
      "Un equipo de desarrollo completo que contratas de una vez: developers, diseñadores, ingenieros y especialistas en seguridad y nube.",
    services: [
      {
        title: "Desarrolladores de Software",
        description:
          "Desarrolladores con experiencia que construyen y mantienen aplicaciones modernas.",
      },
      {
        title: "Diseñadores UX/UI",
        description:
          "Diseñadores que crean interfaces intuitivas que mejoran la experiencia y los resultados.",
      },
      {
        title: "Ingenieros de Software",
        description:
          "Ingenieros senior que diseñan sistemas escalables y cuidan la calidad del código.",
      },
      {
        title: "Especialistas en Cloud & DevOps",
        description:
          "Especialistas en infraestructura cloud y pipelines de despliegue confiables y escalables.",
      },
      {
        title: "Expertos en Seguridad",
        description:
          "Especialistas en ciberseguridad que protegen tus activos digitales y aseguran cumplimiento.",
      },
    ],
  },
  ja: {
    title: "私たちのチームの専門知識",
    description:
      "開発者、デザイナー、エンジニア、セキュリティとクラウドの専門家が揃った開発チームを、まとめて採用できます。",
    services: [
      {
        title: "ソフトウェア開発者",
        description:
          "最新の技術スタックでアプリケーションを構築・運用する経験豊富な開発者。",
      },
      {
        title: "UX/UIデザイナー",
        description:
          "ユーザー体験と成果を高める、直感的なインターフェースを設計するデザイナー。",
      },
      {
        title: "ソフトウェアエンジニア",
        description:
          "スケーラブルな設計とコード品質の担保を担うシニアエンジニア。",
      },
      {
        title: "クラウド＆DevOpsスペシャリスト",
        description:
          "クラウド基盤とデプロイパイプラインで、信頼性の高い拡張可能な環境を構築します。",
      },
      {
        title: "セキュリティ専門家",
        description:
          "デジタル資産を守り、コンプライアンスを確保するセキュリティ専門家。",
      },
    ],
  },
};
